/* eslint-disable max-lines */
/* eslint-disable no-console */
 
import $ from 'jquery';

var logError = function (msg) {
    if (window.console && console.error) {
        console.error(msg);
    }
};

var $doc = $(document),
    qasFilesPath = '/QasClient/',
    addressFormControlNames = {
        street: ['Address1', 'Address2'],
        city: 'City',
        region: 'StateId',
        postcode: 'PostalCode',
        verifiedFlag: 'AddressStandardizationStatus'
    },
    qasVerificationLevel = {
        None: 'None',
        Verified: 'Verified',
        InteractionRequired: 'InteractionRequired',
        StreetPartial: 'StreetPartial',
        PremisesPartial: 'PremisesPartial',
        Multiple: 'Multiple'
    },
    verificationFlag = {
        Standardized: 'Standardized',
        NotStandardized: 'NotStandardized',
        Overridden: 'Overridden'
    },
    responseProcessor = (function () {
        var processUserResponse = function (userResponse, callBack) {
                if (typeof userResponse == 'object') {
                    addressForm.setAddress(userResponse);
                    addressForm.setVerificationFlag(verificationFlag.Standardized);
                    modalDialog.close();
                    callBack();
                } else {
                    switch (userResponse) {
                        case 'edit':
                            modalDialog.close();
                            break;
                        case 'override':
                            addressForm.setVerificationFlag(verificationFlag.Overridden);
                            modalDialog.close();
                            callBack();
                            break;
                    }
                }
            },
            processVerified = function (address, callBack) {
                addressForm.setAddress(address);
                addressForm.setVerificationFlag(verificationFlag.Standardized);
                callBack();
            },
            processInteractionRequired = function (address, originalAddress, callBack) {
                resultsDialog.promptForInteractionRequired(address, originalAddress, function (userResponse) {
                    processUserResponse(userResponse, callBack);
                });
            },
            processStreetPartial = function (picklist, originalAddress, callBack) {
                resultsDialog.promptForStreetPartial(picklist, originalAddress, function (userResponse) {
                    processUserResponse(userResponse, callBack);
                });
            },
            processPremisePartial = function (picklist, originalAddress, callBack) {
                resultsDialog.promptForPremisesPartial(picklist, originalAddress, function (userResponse) {
                    processUserResponse(userResponse, callBack);
                });
            },
            processMultiple = function (picklist, originalAddress, callBack) {
                resultsDialog.promptForMultipleResults(picklist, originalAddress, function (userResponse) {
                    processUserResponse(userResponse, callBack);
                });
            },
            processNoResults = function (originalAddress, callBack) {
                resultsDialog.promptForNoResults(originalAddress, function (userResponse) {
                    processUserResponse(userResponse, callBack);
                });
            },
            processSearchResponse = function (originalAddress, response, callBack) {
                switch (response.verificationLevel) {
                    case qasVerificationLevel.Verified:
                        processVerified(response.address, callBack);
                        break;
                    case qasVerificationLevel.InteractionRequired:
                        processInteractionRequired(response.address, originalAddress, callBack);
                        break;
                    case qasVerificationLevel.StreetPartial:
                        processStreetPartial(response.picklist, originalAddress, callBack);
                        break;
                    case qasVerificationLevel.PremisesPartial:
                        processPremisePartial(response.picklist, originalAddress, callBack);
                        break;
                    case qasVerificationLevel.Multiple:
                        processMultiple(response.picklist, originalAddress, callBack);
                        break;
                    case qasVerificationLevel.None:
                        processNoResults(originalAddress, callBack);
                        break;
                }
            };

        return {
            processSearchResponse: processSearchResponse
        };
    })(),
    resultsDialog = (function () {
        var promptForNoResults = function (originalAddress, callBack) {
                var fileName = getQasDialogFileName(qasVerificationLevel.None);

                modalDialog.openModalFromFile(fileName, function () {
                    var context = $('#qas-none');
                    setOriginalAddressFields(context, originalAddress);
                    attachDialogClickEventHandlers(callBack);
                });
            },
            promptForStreetPartial = function (picklist, originalAddress, userResponseProcessorCallBack) {
                var fileName = getQasDialogFileName(qasVerificationLevel.StreetPartial);

                modalDialog.openModalFromFile(fileName, function () {
                    setAddressFieldsForStreetPartial(picklist, originalAddress, userResponseProcessorCallBack);
                    attachDialogClickEventHandlers(userResponseProcessorCallBack);
                });
            },
            promptForPremisesPartial = function (picklist, originalAddress, userResponseProcessorCallBack) {
                var fileName = getQasDialogFileName(qasVerificationLevel.PremisesPartial);

                modalDialog.openModalFromFile(fileName, function () {
                    setAddressFieldsForPremisePartial(picklist, originalAddress, userResponseProcessorCallBack);
                    attachDialogClickEventHandlers(userResponseProcessorCallBack);
                });
            },
            promptForMultipleResults = function (picklist, originalAddress, userResponseProcessorCallBack) {
                var fileName = getQasDialogFileName(qasVerificationLevel.Multiple);

                modalDialog.openModalFromFile(fileName, function () {
                    setAddressFieldsForMultipleResponses(picklist, originalAddress);

                    $('input[name="qas-multiple"]').on('click', function (e) {
                        updateSubmitButton(e.target.id);
                    });

                    $('#qas-submit').on('click', function () {
                        var selectedId = getSelectedInputID('qas-multiple');

                        if (selectedId !== 'override') {
                            qasService.refineAddressSearch(
                                picklist[selectedId],
                                '',
                                function (refineResponse) {
                                    userResponseProcessorCallBack(refineResponse.address);
                                },
                                function (request, textStatus, errorThrown) {
                                    logError(Date() + ': ' + request + ', ' + textStatus + ', ' + errorThrown);
                                }
                            );
                        }else{
                            userResponseProcessorCallBack('override');
                        }
                    });

                    attachDialogClickEventHandlers(userResponseProcessorCallBack);
                });
            },
            promptForInteractionRequired = function (newAddress, originalAddress, userResponseProcessorCallBack) {
                var fileName = getQasDialogFileName(qasVerificationLevel.InteractionRequired);

                modalDialog.openModalFromFile(fileName, function () {
                    setAddressFieldsForInteractionRequired(originalAddress, newAddress);

                    $('.qas-confirm').on('click', function () {
                        userResponseProcessorCallBack(newAddress);
                    });

                    attachEnterKeyHandler(function () {
                        userResponseProcessorCallBack(newAddress);
                    });

                    attachDialogClickEventHandlers(userResponseProcessorCallBack);
                });
            },
            setOriginalAddressFields = function (context, originalAddress) {
                context.find('#qas-original-lineone').html(originalAddress.street[0]);
                if (originalAddress.street.length > 1) {
                    context.find('#qas-original-linetwo').html(originalAddress.street[1]).css('display', 'block');
                }

                if (originalAddress.street.length > 2) {
                    context.find('#qas-original-linethree').html(originalAddress.street[2]).css('display', 'block');
                }

                context.find('#qas-original-city').html(originalAddress.city);
                context.find('#qas-original-region').html(originalAddress.region);
                context.find('#qas-original-postcode').html(originalAddress.postcode);
            },
            setAddressFieldsForStreetPartial = function (picklist, originalAddress, callBack) {
                var context = $('#qas-street-partial');
                setOriginalAddressFields(context, originalAddress);

                // Trim original building number from the address and put it in the search box
                var trimmedLine = 0;
                for (var line in originalAddress.street) {
                    // Match dashes as well as numbers since Canadian subpremises get messy if we don't
                    if (originalAddress.street[line].search(/^(\d|-)*/) > -1) {
                        $('.qas-change-street-number').val(originalAddress.street[line].match(/^(\d|-)*/)[0]);
                        originalAddress.street[line] = $.trim(originalAddress.street[line].replace(/^(\d|-)*/, ''));
                        trimmedLine = line;
                        break;
                    }
                }

                var changeStreetNumber = function () {
                    var newAddress = $.extend(true, {}, originalAddress);
                    newAddress.street[trimmedLine] =
                        $('.qas-change-street-number').val() + ' ' + newAddress.street[trimmedLine];

                    qasService.searchForAddress(
                        newAddress,
                        function (response) {
                            if (
                                response.verificationLevel == qasVerificationLevel.Verified ||
                                response.verificationLevel == qasVerificationLevel.InteractionRequired
                            ) {
                                callBack(response.address);
                            } else if (response.verificationLevel == qasVerificationLevel.PremisesPartial) {
                                promptForPremisesPartial(picklist, newAddress, () => callBack(newAddress));
                            } else {
                                $('#qas-street-input-feedback').show();
                            }
                        },
                        function (request, textStatus, errorThrown) {
                            logError(Date() + ': ' + request + ', ' + textStatus + ', ' + errorThrown);
                        }
                    );
                };

                if (picklist != null) {
                    for (var item = 0; item < picklist.length; item++) {
                        if (picklist[item].addressText.length > 52) {
                            picklist[item].addressText = picklist[item].addressText.substr(0, 51) + ' ...';
                        }
                        if (picklist[item].fullAddress) {
                            $('#qas-street-partial-list').append(
                                '<tr id="qas-street-partial-' +
                                    item +
                                    '">' +
                                    '	<td class="link partial-street-link">' +
                                    picklist[item].addressText +
                                    '</td>' +
                                    '	<td class="link partial-street-link">' +
                                    picklist[item].postcode +
                                    '</td>' +
                                    '</tr>'
                            );
                            // The item var won't be evaluated correctly in $.trigger('click'), so remember monikers with an array
                            picklist['qas-street-partial-' + item] = picklist[item].moniker;
                        } else {
                            $('#qas-street-partial-list').append(
                                '<tr>' +
                                    '	<td>' +
                                    picklist[item].addressText +
                                    '</td>' +
                                    '	<td>' +
                                    picklist[item].postcode +
                                    '</td>' +
                                    '</tr>'
                            );
                        }
                        $('#qas-street-partial-' + item).on('click', function (e) {
                            qasService.refineAddressSearch(
                                picklist[$(e.currentTarget).attr('id')],
                                '',
                                function (refineResponse) {
                                    callBack(refineResponse.address);
                                },
                                function (request, textStatus, errorThrown) {
                                    logError(Date() + ': ' + request + ', ' + textStatus + ', ' + errorThrown);
                                }
                            );
                        });
                    }
                }

                $('.qas-change-street-number-button').on('click', changeStreetNumber);
                attachEnterKeyHandler(changeStreetNumber);
            },
            setAddressFieldsForPremisePartial = function (picklist, originalAddress, callBack) {
                var context = $('#qas-premises-partial');
                setOriginalAddressFields(context, originalAddress);

                var addSubpremise = function () {
                    var newAddress = $.extend(true, {}, originalAddress);
                    newAddress.street[0] = newAddress.street[0] + ' #' + $('.qas-add-subpremise').val();

                    qasService.searchForAddress(
                        newAddress,
                        function (response) {
                            if (
                                response.verificationLevel == qasVerificationLevel.Verified ||
                                response.verificationLevel == qasVerificationLevel.InteractionRequired
                            ) {
                                callBack(response.address);
                            } else {
                                $('#qas-subpremise-input-feedback').show();
                            }
                        },
                        function (request, textStatus, errorThrown) {
                            logError(Date() + ': ' + request + ', ' + textStatus + ', ' + errorThrown);
                        }
                    );
                };

                $('.qas-add-subpremise-button').on('click', addSubpremise);
                attachEnterKeyHandler(addSubpremise);

                if (picklist != null) {
                    for (var item = 0; item < picklist.length; item++) {
                        if (picklist[item].addressText.length > 52) {
                            picklist[item].addressText = picklist[item].addressText.substr(0, 51) + ' ...';
                        }
                        if (picklist[item].fullAddress) {
                            $('#qas-premises-partial-list').append(
                                '<tr id="qas-premises-partial-' +
                                    item +
                                    '">' +
                                    '	<td class="link premises-partial-link">' +
                                    picklist[item].addressText +
                                    '</td>' +
                                    '	<td class="link premises-partial-link">' +
                                    picklist[item].postcode +
                                    '</td>' +
                                    '</tr>'
                            );
                            // The item var won't be evaluated correctly in $.trigger('click'), so remember monikers with an array
                            picklist['qas-premises-partial-' + item] = picklist[item].moniker;
                        } else {
                            $('#qas-premises-partial-list').append(
                                '<tr>' +
                                    '	<td>' +
                                    picklist[item].addressText +
                                    '</td>' +
                                    '	<td>' +
                                    picklist[item].postcode +
                                    '</td>' +
                                    '</tr>'
                            );
                        }
                        $('#qas-premises-partial-' + item).on('click', function (e) {
                            qasService.refineAddressSearch(
                                picklist[$(e.currentTarget).attr('id')],
                                '',
                                function (refineResponse) {
                                    callBack(refineResponse.address);
                                },
                                function (request, textStatus, errorThrown) {
                                    logError(Date() + ': ' + request + ', ' + textStatus + ', ' + errorThrown);
                                }
                            );
                        });
                    }
                }
            },
            setAddressFieldsForMultipleResponses = function (picklist, originalAddress) {
                var context = $('#qas-multiple');
                setOriginalAddressFields(context, originalAddress);

                var maxAddressLineLength = 45;
                for (var item = 0; item < picklist.length; item++) {
                    if (picklist[item].addressText.length > maxAddressLineLength) {
                        picklist[item].addressText = picklist[item].addressText.substr(0, 44) + ' ...';
                    }

                    $('#qas-multiple-list').append(
                        '<label class="radio qas-address-list qas-multiple-item" data-column="sm" for="qas-multiple-' +
                            item +
                            '">' +
                            '<span class="label-flex"><input type="radio" id="qas-multiple-' +
                            item +
                            '"  name="qas-multiple">' +
                            picklist[item].addressText +
                            ', <br>' +
                            picklist[item].postcode +
                            '</span><span><strong class="color-green">Verified</strong></div>' +
                            '</span>'
                    );
                    // The item var won't be evaluated correctly in $.trigger('click'), so remember monikers with an array
                    picklist['qas-multiple-' + item] = picklist[item].moniker;
                }
            },
            updateSubmitButton = function (id) {
                var submitButton = $('#qas-submit');
                submitButton.attr('disabled', false);

                if (id === 'override') {
                    submitButton.text('Use Unverified Address');
                    submitButton.removeClass('success');
                    submitButton.addClass('purchase');
                } else {
                    submitButton.text('Use Verified Address');
                    submitButton.removeClass('purchase');
                    submitButton.addClass('success');
                }
            },
            getSelectedInputID = function (name) {
                var qasSelectedID = $(`input[name="${name}"]:checked`).attr('id');
                return qasSelectedID;
            },
            setAddressFieldsForInteractionRequired = function (originalAddress, newAddress) {
                var context = $('#qas-interaction-required');
                setOriginalAddressFields(context, originalAddress);

                $('#qas-interaction-required-lineone').html(newAddress.street[0]);

                if (newAddress.street.length > 1) {
                    $('#qas-interaction-required-linetwo').html(newAddress.street[1]).css('display', 'block');

                    if (newAddress.street.length > 2) {
                        $('#qas-interaction-required-linethree').html(newAddress.street[2]).css('display', 'block');
                    }
                }

                $('#qas-interaction-required-city').html(newAddress.city);
                $('#qas-interaction-required-region').html(newAddress.region);
                $('#qas-interaction-required-postcode').html(newAddress.postcode);
                $('#qas-original-lineone').html(originalAddress.street[0]);
            },
            getQasDialogFileName = function (verificationLevel) {
                switch (verificationLevel) {
                    case qasVerificationLevel.InteractionRequired:
                        return qasFilesPath + 'qas-interactionrequired.html';
                    case qasVerificationLevel.StreetPartial:
                        return qasFilesPath + 'qas-streetpartial.html';
                    case qasVerificationLevel.PremisesPartial:
                        return qasFilesPath + 'qas-premisespartial.html';
                    case qasVerificationLevel.Multiple:
                        return qasFilesPath + 'qas-multiple.html';
                    case qasVerificationLevel.None:
                        return qasFilesPath + 'qas-none.html';
                    default:
                        return '';
                }
            },
            attachEnterKeyHandler = function (callBack) {
                $doc.keyup(function (key) {
                    // IE and Mozilla have different key events
                    var keycode = key == null ? event.keyCode : key.which,
                        enterKey = 13;
                    if (keycode == enterKey && callBack) {
                        callBack();
                    }
                });
            },
            attachDialogClickEventHandlers = function (callBack) {
                $doc.keyup(function (key) {
                    // IE and Mozilla have different key events
                    var keycode = key == null ? event.keyCode : key.which,
                        escapeKey = 27;
                    if (keycode == escapeKey) {
                        callBack('edit');
                    }
                });

                $('.qas-edit').on('click', function (event) {
                    event.preventDefault();
                    callBack('edit');
                });

                $('.qas-override').on('click', function (event) {
                    event.preventDefault();
                    callBack('override');
                });
            };

        return {
            promptForNoResults: promptForNoResults,
            promptForStreetPartial: promptForStreetPartial,
            promptForPremisesPartial: promptForPremisesPartial,
            promptForMultipleResults: promptForMultipleResults,
            promptForInteractionRequired: promptForInteractionRequired
        };
    })(),
    addressForm = (function () {
        var selectorContext,
            getInputElement = function (elementName) {
                var selector = 'input[ name = ' + elementName + ']';

                if (selectorContext) {
                    return $(selector, selectorContext);
                }
                return $(selector);
            },
            stripZipPlus4Element = function (zipPlus4Value) {
                if (zipPlus4Value != null && zipPlus4Value.length > 5) {
                    return zipPlus4Value.substring(0, 5);
                }
                return zipPlus4Value;
            },
            getStateValue = function (controlName) {
                return $(`select[name=${controlName.replace(/\$/gi, '_')}] option:selected`, selectorContext).text();
            },
            setStateValue = function (controlName, value) {
                const $select = $(`select[name=${controlName.replace(/\$/gi, '_')}]`, selectorContext);

                return $select.val(findStateValueFromAbbreviation($select.get(0), value));
            },
            setSelectorContext = function (context) {
                selectorContext = context;
            },
            getAddress = function (context) {
                setSelectorContext(context);

                var address = new QasAddress();

                for (var i = 0; i < addressFormControlNames.street.length; i++) {
                    address.street.push(
                        addressForm.removeCharacters(getInputElement(addressFormControlNames.street[i]).val())
                    );
                }
                address.city = addressForm.removeCharacters(getInputElement(addressFormControlNames.city).val());
                address.region = getStateValue(addressFormControlNames.region);
                address.postcode = stripZipPlus4Element(getInputElement(addressFormControlNames.postcode).val());
                return address;
            },
            setAddress = function (address) {
                // Clear existing contents
                var line;
                for (line in addressFormControlNames.street) {
                    getInputElement(addressFormControlNames.street[line]).val('');
                }
                // It's unlikely that QAS will return any more than two street lines, but just in case...
                var newStreet;
                if (address.street.length > addressFormControlNames.street.length) {
                    newStreet = address.street.join(' ');
                    getInputElement(addressFormControlNames.street[0]).val(newStreet);
                } else {
                    for (line in address.street) {
                        getInputElement(addressFormControlNames.street[line]).val(address.street[line]);
                    }
                }

                getInputElement(addressFormControlNames.city).val(address.city);
                setStateValue(addressFormControlNames.region, address.region);
                getInputElement(addressFormControlNames.postcode).val(address.postcode);
            },
            removeCharacters = function (inputString) {
                return inputString.trim();
            },
            setVerificationFlag = function (flag) {
                // string (NotStandardized, Standardized, Overridden)
                getInputElement(addressFormControlNames.verifiedFlag).val(flag);
            };

        function findStateValueFromAbbreviation($select, abbreviation) {
            const stateMap = { "AA": "AA", "AE": "AE", "AK": "Alaska", "AL": "Alabama", "AP": "AP", "AR": "Arkansas", "AZ": "Arizona", "CA": "California", "CO": "Colorado", "CT": "Connecticut", "DE": "Delaware", "FL": "Florida", "GA": "Georgia", "HI": "Hawaii", "IA": "Iowa", "ID": "Idaho", "IL": "Illinois", "IN": "Indiana", "KS": "Kansas", "KY": "Kentucky", "LA": "Louisiana", "MA": "Massachusetts", "MD": "Maryland", "ME": "Maine", "MI": "Michigan", "MN": "Minnesota", "MO": "Missouri", "MS": "Mississippi", "MT": "Montana", "NC": "North Carolina", "ND": "North Dakota", "NE": "Nebraska", "NH": "New Hampshire", "NJ": "New Jersey", "NM": "New Mexico", "NV": "Nevada", "NY": "New York", "OH": "Ohio", "OK": "Oklahoma", "OR": "Oregon", "PA": "Pennsylvania", "RI": "Rhode Island", "SC": "South Carolina", "SD": "South Dakota", "TN": "Tennessee", "TX": "Texas", "UT": "Utah", "VA": "Virginia", "VT": "Vermont", "WA": "Washington", "WI": "Wisconsin", "WV": "West Virginia", "WY": "Wyoming" };

            const isFullNameMatch = (state, abbreviation) => state === stateMap[abbreviation];
            const isAbbreviationMatch = (state, abbreviation) => state === abbreviation;

            return [...$select.options].find($option => {
                const state = $option.innerText?.trim();
                return isAbbreviationMatch(state, abbreviation) || isFullNameMatch(state, abbreviation);
            })?.value;
        }

        return {
            setSelectorContext: setSelectorContext,
            getAddress: getAddress,
            setAddress: setAddress,
            removeCharacters: removeCharacters,
            setVerificationFlag: setVerificationFlag
        };
    })(),
    qasService = (function () {
        // Leave set as "Database layout" unless using custom output formatting
        var qasDefaultLayout = 'Database layout',
            qasDefaultCountry = 'USA',
            getQasSuggestions = function (parameters, successCallback, errorCallback) {
                var defaultParameters = {
                    country: qasDefaultCountry,
                    layout: qasDefaultLayout
                };

                $.ajax({
                    type: 'GET',
                    url:
                        '/api/addressVerification/VerifyAddress?' +
                        $.param($.extend({}, defaultParameters, parameters)),
                    dataType: 'xml',
                    success: parseXmlResponseToQasResponse(processBestPractices(successCallback)),
                    error: errorCallback,
                    timeout: 5500
                });
            },
            searchForAddress = function (address, successCallback, errorCallback) {
                address = address.replaceUnprintableCharacters();
                // turn off city retention
                address.city = '@' + address.city;
                var parameters = {
                    requestAction: 'search',
                    promptset: 'Default',
                    // JavaScript doesn't let you call join on a method parameter, so we have to use an Array prototype
                    searchstring: [
                        Array.prototype.join.call(address.street, '|'),
                        address.city,
                        address.region,
                        address.postcode
                    ].join('|')
                };

                getQasSuggestions(parameters, successCallback, errorCallback);
            },
            refineAddressSearch = function (moniker, refineText, successCallback, errorCallback) {
                var parameters = {
                    requestAction: 'refine',
                    moniker: moniker,
                    refinetext: refineText
                };
                getQasSuggestions(parameters, successCallback, errorCallback);
            },
            parseXmlResponseToQasResponse = function (callBack) {
                return function (xml) {
                    var $responseXml = $(xml),
                        results = new QasResults();

                    results.verificationLevel = $responseXml.find('verifylevel').text();

                    if ($responseXml.find('picklist').length > 0) {
                        results.picklist = new Array();
                        $responseXml.find('picklistitem').each(function (index, item) {
                            var picklistItem = new QasPicklistItem(),
                                $element = $(item);
                            picklistItem.unresolvableRange = eval(
                                $element.find('unresolvablerange').text().toLowerCase()
                            );
                            picklistItem.fullAddress = eval($element.find('fulladdress').text().toLowerCase());
                            picklistItem.addressText = $element.find('addresstext').text();
                            picklistItem.postcode = $element.find('postcode').text();
                            picklistItem.moniker = $element.find('moniker').text();
                            results.picklist[results.picklist.length] = picklistItem;
                        });
                    } else if ($responseXml.find('address').length > 0) {
                        results.address = new QasAddress();
                        results.address.street[0] = $responseXml.find('lineone').text();
                        if ($responseXml.find('linetwo').text() != '') {
                            results.address.street[1] = $responseXml.find('linetwo').text();
                        }
                        if ($responseXml.find('linethree').text() != '') {
                            results.address.street[2] = $responseXml.find('linethree').text();
                        }
                        results.address.city = $responseXml.find('city').text();
                        results.address.region = $responseXml.find('state').text();
                        results.address.postcode = $responseXml.find('zip').text();
                        results.address.subpremiseFlag = eval($responseXml.find('apartment').text().toLowerCase());

                        // Leave the DPV flag null if the proxy doesn't return one or indicates it isn't set up
                        var dpvFlag = $responseXml.find('DPVStatus').text();
                        if (dpvFlag != '' && dpvFlag != 'DPVNotConfigured') {
                            results.address.dpvFlag = $responseXml.find('DPVStatus').text();
                        }
                    }
                    callBack(results);
                };
            },
            processBestPractices = function (callBack) {
                return function (qasResults) {
                    // Set ready to false if further searches are required to avoid flashing multiple dialogs
                    var ready = true;

                    if (qasResults.verificationLevel == null) {
                        return false;
                    }
                    var processedResults = $.extend(true, {}, qasResults);
                    if (processedResults.address) {
                        // You can replicate the kinds of artifacts we're removing here by doing a
                        // single line search for "Apt" w/ USA or CAN data
                        if (processedResults.address.hasBuildingArtifact()) {
                            processedResults.address.street.shift();
                            processedResults.address.street.push('');
                        }

                        switch (processedResults.address.dpvFlag) {
                            case 'DPVNotConfirmed':
                                processedResults.verificationLevel = qasVerificationLevel.StreetPartial;
                                break;
                            case 'DPVConfirmedMissingSec':
                                processedResults.verificationLevel = qasVerificationLevel.InteractionRequired;
                                break;
                        }
                    }

                    switch (processedResults.verificationLevel) {
                        case qasVerificationLevel.PremisesPartial:
                            if (
                                processedResults.picklist &&
                                processedResults.picklist.length == 1 &&
                                processedResults.picklist[0].fullAddress
                            ) {
                                ready = false;

                                qasService.refineAddressSearch(
                                    processedResults.picklist[0].moniker,
                                    '',
                                    function (response) {
                                        if (response.verificationLevel == qasVerificationLevel.Verified) {
                                            response.verificationLevel = qasVerificationLevel.InteractionRequired;
                                        }
                                        callBack(response);
                                    },
                                    function (request, textStatus, errorThrown) {
                                        logError(Date() + ': ' + request + ', ' + textStatus + ', ' + errorThrown);
                                    }
                                );
                            }
                            break;
                        case qasVerificationLevel.Multiple:
                            for (var item = 0; item < processedResults.picklist.length; item++) {
                                if (processedResults.picklist[item].unresolvableRange) {
                                    processedResults.verificationLevel = qasVerificationLevel.StreetPartial;
                                    break;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                    if (ready) {
                        callBack(processedResults);
                    }
                    return ready;
                };
            };

        return {
            searchForAddress: searchForAddress,
            refineAddressSearch: refineAddressSearch
        };
    })();

function QasResults() {
    return {
        verificationLevel: null,
        picklist: null,
        address: null
    };
}

function QasPicklistItem() {
    return {
        unresolvableRange: null,
        fullAddress: null,
        addressText: null,
        postcode: null,
        moniker: null
    };
}

function QasAddress() {
    return {
        street: new Array(),
        city: null,
        region: null,
        postcode: null,
        subpremiseFlag: null,
        dpvFlag: null,
        containsDash: function () {
            return this.street.toString().search(/-/) > -1;
        },

        // Canada Post and USPS data contain addresses with artifacts wherein the building
        // descriptors are on their own in line one
        hasBuildingArtifact: function () {
            var buildingDescriptors = new Array(
                'Business',
                'Building',
                'Bldg',
                'Business Bldg',
                'Business Bldg.',
                'Business Building',
                'Business Complex',
                'Business Plaza',
                'Immeuble Commercial',
                'Apt',
                'Apartment',
                'Apartment Bldg',
                'Apartment Bldg.',
                'Apartment Building',
                'Immeuble a Appartements',
                'Townhomes',
                'Townhouses'
            );
            return $.inArray(this.street[0], buildingDescriptors) > -1;
        },

        // Match specific unicode characters and convert them to their codes to ensure that
        // they will be passed and interpreted correctly by QAS web services
        replaceUnprintableCharacters: function () {
            var processString = function (string) {
                    if (typeof string == 'string') {
                        var unprintableCharacters = /[\u0026\u00bf-\u00ff]/;
                        while (string.search(unprintableCharacters) != -1) {
                            var characterIndex = string.search(unprintableCharacters);
                            string =
                                string.substring(0, characterIndex) +
                                '%' +
                                string.charCodeAt(characterIndex) +
                                string.substring(characterIndex + 1, string.length);
                        }
                    }
                    return string;
                },
                processedAddress = new QasAddress();
            for (var line in this.street) {
                processedAddress.street[line] = processString(this.street[line]);
            }
            processedAddress.city = processString(this.city);
            processedAddress.region = processString(this.region);
            processedAddress.postcode = processString(this.postcode);
            return processedAddress;
        }
    };
}

export const verifyAddress = function (jqueryContext, callBack) {
    try {
        var originalAddress = addressForm.getAddress(jqueryContext),
            processSearchResponse = function (response) {
                responseProcessor.processSearchResponse(originalAddress, response, callBack);
            },
            processErrorResponse = function (request, textStatus, errorThrown) {
                logError(Date() + ': ' + request + ', ' + textStatus + ', ' + errorThrown);

                addressForm.setVerificationFlag(verificationFlag.NotStandardized);

                if (callBack) {
                    callBack();
                }
            };

        qasService.searchForAddress(originalAddress, processSearchResponse, processErrorResponse);
    } catch (error) {
        logError('verifyAddress exception ' + error);

        if (callBack) {
            callBack();
        }
    }

    return false;
};

export const modalDialog = {
    _modal: null,
    openModalFromFile: function (filePath, callBack) {
        if (this._modal) {
            this._modal.close();
        }

        $.get(filePath).done(html => {
            var $container = $('<div id="qasModal" class="jsHide" />').html(html).appendTo('body');

            this._modal = smartPak.ui.modal($container.get(0), {
                title: 'Shipping Address Verification',
                modalClass: 'qas-verify-modal',
                width: 580,
                removeContents: true
            });

            $('.dialog.is-open.qas-verify-modal').attr('data-message', 'warning');

            if (typeof callBack === 'function') {
                callBack();
            }
        });
    },
    close: function () {
        $doc.off('keyup');
        this._modal.close();
    }
};
